{
  "verified": "2026-09-13",
  "url": "https://www.census.gov/econ/bfs/csv/bfs_monthly.csv",
  "sha256": "f38c4ccdd4cd5bc9a97711f9c3f36de2bab2f4c6b0eb87c2b4df1316edb06adf",
  "rows": [
    {
      "geography": "US",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 576512,
      "august": 531728,
      "line": 23
    },
    {
      "geography": "US",
      "industry": "NAICS11",
      "series": "BA_BA",
      "july": 3958,
      "august": 3859,
      "line": 24
    },
    {
      "geography": "US",
      "industry": "NAICS21",
      "series": "BA_BA",
      "july": 537,
      "august": 559,
      "line": 25
    },
    {
      "geography": "US",
      "industry": "NAICS22",
      "series": "BA_BA",
      "july": 565,
      "august": 525,
      "line": 26
    },
    {
      "geography": "US",
      "industry": "NAICS23",
      "series": "BA_BA",
      "july": 48801,
      "august": 48120,
      "line": 27
    },
    {
      "geography": "US",
      "industry": "NAICSMNF",
      "series": "BA_BA",
      "july": 7875,
      "august": 7910,
      "line": 28
    },
    {
      "geography": "US",
      "industry": "NAICS42",
      "series": "BA_BA",
      "july": 9740,
      "august": 9998,
      "line": 29
    },
    {
      "geography": "US",
      "industry": "NAICSRET",
      "series": "BA_BA",
      "july": 140604,
      "august": 104087,
      "line": 30
    },
    {
      "geography": "US",
      "industry": "NAICSTW",
      "series": "BA_BA",
      "july": 34947,
      "august": 35175,
      "line": 31
    },
    {
      "geography": "US",
      "industry": "NAICS51",
      "series": "BA_BA",
      "july": 13136,
      "august": 13180,
      "line": 32
    },
    {
      "geography": "US",
      "industry": "NAICS52",
      "series": "BA_BA",
      "july": 20222,
      "august": 20137,
      "line": 33
    },
    {
      "geography": "US",
      "industry": "NAICS53",
      "series": "BA_BA",
      "july": 26150,
      "august": 23670,
      "line": 34
    },
    {
      "geography": "US",
      "industry": "NAICS54",
      "series": "BA_BA",
      "july": 81008,
      "august": 80691,
      "line": 35
    },
    {
      "geography": "US",
      "industry": "NAICS55",
      "series": "BA_BA",
      "july": 6784,
      "august": 6853,
      "line": 36
    },
    {
      "geography": "US",
      "industry": "NAICS56",
      "series": "BA_BA",
      "july": 37488,
      "august": 37796,
      "line": 37
    },
    {
      "geography": "US",
      "industry": "NAICS61",
      "series": "BA_BA",
      "july": 8550,
      "august": 8657,
      "line": 38
    },
    {
      "geography": "US",
      "industry": "NAICS62",
      "series": "BA_BA",
      "july": 33813,
      "august": 32522,
      "line": 39
    },
    {
      "geography": "US",
      "industry": "NAICS71",
      "series": "BA_BA",
      "july": 15037,
      "august": 15191,
      "line": 40
    },
    {
      "geography": "US",
      "industry": "NAICS72",
      "series": "BA_BA",
      "july": 30094,
      "august": 26892,
      "line": 41
    },
    {
      "geography": "US",
      "industry": "NAICS81",
      "series": "BA_BA",
      "july": 44301,
      "august": 43221,
      "line": 42
    },
    {
      "geography": "US",
      "industry": "NONAICS",
      "series": "BA_BA",
      "july": 12902,
      "august": 12687,
      "line": 43
    },
    {
      "geography": "AL",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 7694,
      "august": 6206,
      "line": 53
    },
    {
      "geography": "AK",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 1371,
      "august": 1413,
      "line": 55
    },
    {
      "geography": "AZ",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 14003,
      "august": 12399,
      "line": 57
    },
    {
      "geography": "AR",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 5032,
      "august": 3813,
      "line": 59
    },
    {
      "geography": "CA",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 60996,
      "august": 55619,
      "line": 61
    },
    {
      "geography": "CO",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 17197,
      "august": 15602,
      "line": 63
    },
    {
      "geography": "CT",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 5025,
      "august": 4916,
      "line": 65
    },
    {
      "geography": "DE",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 5292,
      "august": 4985,
      "line": 67
    },
    {
      "geography": "DC",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 1414,
      "august": 1243,
      "line": 69
    },
    {
      "geography": "FL",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 65129,
      "august": 61380,
      "line": 71
    },
    {
      "geography": "GA",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 25968,
      "august": 23383,
      "line": 73
    },
    {
      "geography": "HI",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 1472,
      "august": 1450,
      "line": 75
    },
    {
      "geography": "ID",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 3460,
      "august": 3431,
      "line": 77
    },
    {
      "geography": "IL",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 18268,
      "august": 16559,
      "line": 79
    },
    {
      "geography": "IN",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 10642,
      "august": 8363,
      "line": 81
    },
    {
      "geography": "IA",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 3330,
      "august": 3337,
      "line": 83
    },
    {
      "geography": "KS",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 4430,
      "august": 3941,
      "line": 85
    },
    {
      "geography": "KY",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 7083,
      "august": 6751,
      "line": 87
    },
    {
      "geography": "LA",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 7263,
      "august": 6793,
      "line": 89
    },
    {
      "geography": "ME",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 1453,
      "august": 1538,
      "line": 91
    },
    {
      "geography": "MD",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 9098,
      "august": 8922,
      "line": 93
    },
    {
      "geography": "MA",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 7506,
      "august": 7596,
      "line": 95
    },
    {
      "geography": "MI",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 16547,
      "august": 14883,
      "line": 97
    },
    {
      "geography": "MN",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 6690,
      "august": 8078,
      "line": 99
    },
    {
      "geography": "MS",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 6911,
      "august": 5561,
      "line": 101
    },
    {
      "geography": "MO",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 12170,
      "august": 11239,
      "line": 103
    },
    {
      "geography": "MT",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 2734,
      "august": 2897,
      "line": 105
    },
    {
      "geography": "NE",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 2055,
      "august": 1995,
      "line": 107
    },
    {
      "geography": "NV",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 6182,
      "august": 5757,
      "line": 109
    },
    {
      "geography": "NH",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 1903,
      "august": 1797,
      "line": 111
    },
    {
      "geography": "NJ",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 15850,
      "august": 15873,
      "line": 113
    },
    {
      "geography": "NM",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 3434,
      "august": 3901,
      "line": 115
    },
    {
      "geography": "NY",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 31068,
      "august": 26762,
      "line": 117
    },
    {
      "geography": "NC",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 17657,
      "august": 16692,
      "line": 119
    },
    {
      "geography": "ND",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 868,
      "august": 906,
      "line": 121
    },
    {
      "geography": "OH",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 16115,
      "august": 14822,
      "line": 123
    },
    {
      "geography": "OK",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 6805,
      "august": 5318,
      "line": 125
    },
    {
      "geography": "OR",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 5725,
      "august": 5500,
      "line": 127
    },
    {
      "geography": "PA",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 13943,
      "august": 14285,
      "line": 129
    },
    {
      "geography": "RI",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 1064,
      "august": 1114,
      "line": 131
    },
    {
      "geography": "SC",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 9537,
      "august": 8406,
      "line": 133
    },
    {
      "geography": "SD",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 1234,
      "august": 1270,
      "line": 135
    },
    {
      "geography": "TN",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 11061,
      "august": 9613,
      "line": 137
    },
    {
      "geography": "TX",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 55981,
      "august": 48692,
      "line": 139
    },
    {
      "geography": "UT",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 7683,
      "august": 7682,
      "line": 141
    },
    {
      "geography": "VT",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 736,
      "august": 783,
      "line": 143
    },
    {
      "geography": "VA",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 12795,
      "august": 13103,
      "line": 145
    },
    {
      "geography": "WA",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 9837,
      "august": 9874,
      "line": 147
    },
    {
      "geography": "WV",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 1654,
      "august": 1734,
      "line": 149
    },
    {
      "geography": "WI",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 7629,
      "august": 6380,
      "line": 151
    },
    {
      "geography": "WY",
      "industry": "TOTAL",
      "series": "BA_BA",
      "july": 7518,
      "august": 7171,
      "line": 153
    },
    {
      "geography": "US",
      "industry": "TOTAL",
      "series": "BF_PBF4Q",
      "july": 29860,
      "august": 28501,
      "line": 639
    }
  ]
}
